import type { ReactNode } from 'react';
import { ReturnArtifacts } from './ReturnArtifacts';
import { ItemDisplay } from './ItemDisplay';
import { Flex } from '@repo/ui/Flex';
import s from './Widgets.module.css';
import { LocationPreviewCard } from '../Locations/LocationPreviewCard';
import { formatLocationAddressSingle } from '../../utils/address';
import { hoursToString } from '../Locations/openingHours';
import type { WidgetProps } from './types';
import { ItemDetailsModal } from './ItemDetailsModal/ItemDetailsModal';
import { buildItemsPreviewData, resolveWidgetKeys } from './helpers';
import { ConfirmationEmail } from './ConfirmationEmail';

export const Widget = ({
  context,
  label,
  orderItems,
  rawOrderItems,
  location,
  qrCode,
  deliveryMethod,
  deliveryType,
  status,
  pollingStatus,
  requestId,
  requestItems,
  email,
  count,
  claimId,
}: WidgetProps) => {
  let widget: ReactNode = null;

  if (context === 'label' || context === 'printerless') {
    widget = (
      <ReturnArtifacts
        label={label}
        qrCode={qrCode}
        deliveryMethod={deliveryMethod}
        status={status}
        pollingStatus={pollingStatus}
      />
    );
  } else if (context === 'items' && orderItems && orderItems.length > 0) {
    const itemsPreviewData = buildItemsPreviewData({
      orderItems: rawOrderItems,
      requestItems,
      claimId,
    });

    if (itemsPreviewData) {
      widget = (
        <ItemDetailsModal
          items={itemsPreviewData.items}
          itemCountText={itemsPreviewData.itemCountText}
          viewDetailsText={itemsPreviewData.viewDetailsText}
        />
      );
    } else {
      widget = (
        <Flex className={s.itemsWrapper} padding="p-12" gap="g-12">
          <ItemDisplay items={orderItems} />
        </Flex>
      );
    }
  } else if (context === 'location' && location) {
    widget = (
      <Flex className={s.locationWrapper} padding="p-12" gap="g-12">
        <LocationPreviewCard
          title={location.storeName}
          description={formatLocationAddressSingle(location.address)}
          icon={location.logoUrl}
          attribute={`${location.distance ?? ''}`}
          hours={hoursToString({
            locationHours: location.openingHours,
          })}
        />
      </Flex>
    );
  } else if (context === 'email' && requestId) {
    const { iconKey, descriptionKey } = resolveWidgetKeys({
      status,
      type: deliveryType,
      packaging: deliveryMethod?.packagingOption,
      count,
      keyPrefix: 'pdx',
    });

    widget = (
      <ConfirmationEmail
        email={email}
        requestId={requestId}
        iconKey={iconKey}
        descriptionKey={descriptionKey}
      />
    );
  }
  return <div>{widget}</div>;
};
